import { call, put, select, takeLatest } from 'redux-saga/effects';

import { accountUtils } from '@talend/dataset';
import { isShowDatasetGuidedTour } from '@talend/dataset/lib/modules/DatasetGuidedTour';
import { isFastStartAllowed } from '@talend/dataset/lib/modules/SnowflakeFastStart';
import { featureFlippingSelectors, featureFlippingUtils } from '@talend/feature-flipping';
import { push } from '@talend/router-bridge';

import { FEATURE_FLAGS } from '../../../constants';
import { isTrialAccount } from '../../../utils/account.cache';
import {
	showGuidedTour as showGuidedTourActionCreator,
	showGuidedTourHome,
	TDC_GUIDED_TOUR_INITIALIZE,
	TDC_GUIDED_TOUR_SHOW,
} from './GuidedTour.actions';

export function* initializeGuidedTour(): Generator<any, void, any> {
	// To be removed this way
	yield call(featureFlippingUtils.waitUntilLoaded);
	if (isTrialAccount()) {
		return;
	}

	// Check if we show the dataset guided tour
	const isShowDatasetTour: boolean = yield call(isShowDatasetGuidedTour);

	if (isShowDatasetTour) {
		return;
	}

	let showTour = true;

	const isSnowflake = accountUtils.isSnowflakeUser();

	if (isSnowflake) {
		const fastStartAllowed = yield call(isFastStartAllowed);

		if (fastStartAllowed) {
			showTour = false;
		}
	}

	if (showTour) {
		yield put(showGuidedTourActionCreator());
	}
}

export function* showGuidedTour(): Generator<any, void, any> {
	const isShowDatasetTour: boolean = yield call(isShowDatasetGuidedTour);
	if (isShowDatasetTour) {
		return;
	}
	if (accountUtils.isSnowflakeUser()) {
		yield put(push('/connections', null, { type: 'GO_TO_CONNECTION_LIST' }));
	} else {
		yield call(featureFlippingUtils.waitUntilLoaded);
		const flag = yield select(
			featureFlippingSelectors.getFlag,
			FEATURE_FLAGS.DATA_HEALTH_CONSOLE_ENABLED,
		);
		if (flag) {
			yield put(push('/data-console', null, { type: 'BACK_TO_HOME' }));
		} else {
			yield put(push('/datasets', null, { type: 'BACK_TO_HOME' }));
		}
	}

	yield put(showGuidedTourHome());
}

export function* guidedTourSaga() {
	yield takeLatest(TDC_GUIDED_TOUR_INITIALIZE, initializeGuidedTour);
	yield takeLatest(TDC_GUIDED_TOUR_SHOW, showGuidedTour);
}
